import SortPopup, { SortOption } from "../../../../components/sort_popup/sort_popup";

export type ServicesSortOption = "newest" | "oldest" | "nameAsc" | "nameDesc";

export const DEFAULT_SERVICES_SORT_OPTION: ServicesSortOption = "newest";

const OPTIONS: SortOption<ServicesSortOption>[] = [
  { value: "newest", label: "New to old" },
  { value: "oldest", label: "Old to new" },
  { value: "nameAsc", label: "Name (A-Z)" },
  { value: "nameDesc", label: "Name (Z-A)" },
];

export function servicesSortOptionLabel(option: ServicesSortOption): string {
  return OPTIONS.find((o) => o.value === option)!.label;
}

export function servicesSortOptionToParams(option: ServicesSortOption): {
  sortBy: "createdAt" | "name";
  sortOrder: "ASC" | "DESC";
} {
  switch (option) {
    case "newest":
      return { sortBy: "createdAt", sortOrder: "DESC" };
    case "oldest":
      return { sortBy: "createdAt", sortOrder: "ASC" };
    case "nameAsc":
      return { sortBy: "name", sortOrder: "ASC" };
    case "nameDesc":
      return { sortBy: "name", sortOrder: "DESC" };
  }
}

export default function SortServicesPopup({
  open,
  onClose,
  sortOption,
  setSortOption,
}: {
  open: boolean;
  onClose: () => void;
  sortOption: ServicesSortOption;
  setSortOption: (option: ServicesSortOption) => void;
}) {
  return (
    <SortPopup
      open={open}
      onClose={onClose}
      title="Sort Services"
      options={OPTIONS}
      value={sortOption}
      onApply={setSortOption}
    />
  );
}
